module.exports = __webpack_public_path__ + "static/media/foto4.329f60d2.JPG";